/**
 * The name-only half of the server's outbound target rule (R19, outbound-target.ts). The
 * server also resolves the name before a test; that part cannot run here, so this check
 * only gives early feedback and refuses nothing the server would accept.
 */
const DOTTED_IPV4_RE = /^\d{1,3}(\.\d{1,3}){3}$/;
/** Decimal or hex, as inet_aton reads `127.1` or `127.0.0.0x1`; no real TLD looks like this. */
const NUMERIC_LABEL_RE = /^(0x[0-9a-f]*|\d+)$/i;
const BLOCKED_SUFFIXES = ['.localhost', '.local', '.internal'];
const METADATA_HOSTS = new Set(['metadata.google.internal', 'metadata.goog', 'instance-data']);

/** A hostname holds a colon only as an IPv6 literal; a dotted quad is an IPv4 one. */
function isIpLiteral(host: string): boolean {
    return host.includes(':') || DOTTED_IPV4_RE.test(host);
}

/**
 * Any IP literal, single-label and local names, metadata names, and a numeric last label.
 * Trailing dots (`localhost..`) are dropped first, as on the server.
 */
export function isBlockedHostname(hostname: string): boolean {
    const host = hostname.toLowerCase().replace(/\.+$/, '');
    const bare = host.startsWith('[') && host.endsWith(']') ? host.slice(1, -1) : host;
    if (isIpLiteral(bare)) return true;
    const labels = host.split('.');
    if (labels.length < 2 || NUMERIC_LABEL_RE.test(labels[labels.length - 1])) return true;
    if (BLOCKED_SUFFIXES.some((suffix) => host.endsWith(suffix))) return true;
    return METADATA_HOSTS.has(host);
}
